<template>
  <div class="amount-panel-container flex flex-col">
    <img
      src="@/assets/order/shouhuodizhi.svg"
      class="w-full flex-grow-0"
      alt=""
    />
    <div class="flex-grow p-3">
      <div class="font-medium">
        {{ data.recipients }}&nbsp;{{ data.recipientsMobile }}
      </div>
      <div class="text-sm" style="color: #999999">
        {{ data.areaName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less" scoped>
.amount-panel-container {
  margin: 28px 0 28px 0;

  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
}
</style>